module.exports = __webpack_public_path__ + "media/images/categories/icon_cat24-ec626792cd842b93e4f5208480cc21a4.svg";